/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ref_N5Inputs */

const en_viewer_ref_n5 = /** @type {(inputs: Viewer_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrays and objects are labelled separately, which bracket counting does not do for you.`)
};

const ko_viewer_ref_n5 = /** @type {(inputs: Viewer_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배열과 객체가 따로 표시됩니다. 괄호를 세는 것으로는 알 수 없는 일입니다.`)
};

const ja_viewer_ref_n5 = /** @type {(inputs: Viewer_Ref_N5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列とオブジェクトが別々に表示されます。かっこを数えるだけでは分からないことです。`)
};

/**
* | output |
* | --- |
* | "Arrays and objects are labelled separately, which bracket counting does not do for you." |
*
* @param {Viewer_Ref_N5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ref_n5 = /** @type {((inputs?: Viewer_Ref_N5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ref_N5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ref_n5(inputs)
	if (locale === "ko") return ko_viewer_ref_n5(inputs)
	return ja_viewer_ref_n5(inputs)
});